import { SERVICING_ROUTES } from '@conf/routes.config';

/**
 * コンテンツ領域にて l-wrap__inner を無効にするURL
 */
export const DISABLED_WRAP_INNER_URLS = [
  // EMD検索画面
  `/${SERVICING_ROUTES.emdSearch}`,

  // 領収書検索画面
  `/${SERVICING_ROUTES.receiptSearch}`,

  // Ancillary購入完了
  `/${SERVICING_ROUTES.serviceRequestCompleted}`,

  // 搭乗証明書検索
  `/${SERVICING_ROUTES.boardingCertificateSearch}`,
] as string[];
